export enum eJournalEntryType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

/**
 * !WARNING! READ THIS BEFORE CHANGING ANYTHING
 * Escrow System is internally consistent regarding Entry Types. We align with what the Bank and BAI files specify
 * This is not in alignment with expectations of Finance Team.
 * This option list swaps the Label & Value to reduce confusion for Finance while preserving Direction in the Escrow System
 * If you need Label/Value that is not swapped, be sure to preserve this swapped version for any UX that is used by Finance Team
 */
export const prettyJournalEntryType: Record<eJournalEntryType, string> = {
  CREDIT: 'Debit',
  DEBIT: 'Credit',
};

export const journalEntryTypeOptions = Object.entries(prettyJournalEntryType).map(([key, value]) => ({
  label: value,
  value: key as eJournalEntryType,
}));
